'use client';

import type { NextPage } from 'next';
import { STATIC_PAGES_PHRASES } from '@/consts/phrases/staticPagesPhrases';
import { DefaultPageProps } from '@/types/types/page/pages';
import { useInitialPageLoad } from '@/hooks/general/useInitialPageLoad';
import { MainContentWrapper } from '@/components/layout/MainContentWrapper/MainContentWrapper';
import { StaticPage } from '@/components/layout/StaticPage/StaticPage';

const TermsAndConditionsPage: NextPage<DefaultPageProps> = ({ phrases, dictionary }) => {
    useInitialPageLoad({ phrases, countries: dictionary.countries });
    return (
        <MainContentWrapper
            phrases={phrases}
            dictionary={dictionary}
            className="page-terms-and-conditions"
        >
            <StaticPage
                headingPhraseId={STATIC_PAGES_PHRASES.TERMS_AND_CONDITIONS_TITLE}
                contentPhraseId={STATIC_PAGES_PHRASES.TERMS_AND_CONDITIONS_CONTENT}
            ></StaticPage>
        </MainContentWrapper>
    );
};

export default TermsAndConditionsPage;
